import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Classnames from 'classnames'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Select from 'react-select'
import './TickerSelect.css'


const colourStyles = {
  control: base => ({
    ...base,
    borderRadius: 0
  }),
  option: (provided, state) => ({
    ...provided,
    color: '#050139',
    fontSize: 14,
    ':active': {
      backgroundColor: state.isSelected ? 'white' : '#050139',
      color: state.isSelected ? '#050139' : 'white'
    },
    ':hover': {
      backgroundColor: state.isSelected ? 'white' : '#050139',
      color: state.isSelected ? '#050139' : 'white'
    }
  }),
  menu: base => ({
    ...base,
    borderRadius: 0,
    borderColor: '#050139'
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1
    const transition = 'opacity 100ms'

    return { ...provided, opacity, transition }
  },
  multiValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 0.75
    const fontSize = '14px'
    const zIndex = 9999
    return { ...provided, opacity, fontSize, zIndex }
  },
  dropdownIndicator: base => ({
    ...base,
    color: '#050139'
  })
}

const Selector = ({ strategiesToList, placeholder, handleEntitySelection }) => {

  if (!strategiesToList || strategiesToList.length === 0 || strategiesToList === '') {
    return null
  }

  const options = strategiesToList
    .map(strategy => ({
      value: strategy.id,
      label: strategy.ticker + ' - ' + strategy.name,
      name: strategy.name,
      type: strategy.type,   
      ticker: strategy.ticker,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))

  return (
      <Select 
        isMulti 
        options={options} 
        onChange={e => handleEntitySelection({'id': e[0]?.value, 'name': e[0]?.name, 'ticker': e[0]?.ticker, 'type': e[0]?.type})}
        placeholder={placeholder} 
        noOptionsMessage={() => null}    
        components={{ IndicatorSeparator: null }} 
        loseMenuOnSelect={true} 
        blurInputOnSelect={false} 
        clearable={true} 
        value={''} 
        styles={colourStyles} />
  )
}

const TickerSelect = ({ updateSelection, wtCategory, placeholder, tabIndex, bannedSearches}) => {
  // get from redux
  const clientEmail = useSelector(state => state.params.params.clientEmail)
  const token = useSelector(state => state.params.params.token)

  // set local states
  const [suggestions, setSuggestions] = useState([])
  const [loading, setLoading] = useState(false)

  // query the db for the list of swap options
  useEffect(() => {
    console.log('suggestions', suggestions.legnth)
    if (suggestions.length == 0) {
      getSuggestions()
    }
  },[])

  // call back for the ticker the user decides to swap
  const handleEntitySelection = suggestion => {
    if (suggestion.id) {
      updateSelection(suggestion)
    }
    
  }

  // function to query the database
  const getSuggestions = async query => {
    setLoading(true) 

    const url = `${process.env.REACT_APP_API_URL}/modelhighlights/modelcustomswapsearch/`

    if (token !== undefined) {
      const request = {
        method: 'GET',
        url: url,
        params: {
          clientEmail: clientEmail,
          wtCategory: wtCategory
        },
        headers: {
          Authorization: token && `Token ${token}`
        }
      }

      return axios(request)
        .then(response => {
          if (response.status === 200) {  
            setLoading(false)        
            setSuggestions(response.data)
          }
        })
        .catch(error => {
          console.error(error)
          setSuggestions([])
          setLoading(false)
        })
    }
  }

  // show a spinner while we wait for the db to return the list
  if (loading) {
    return (
      <div className='portfolio-hub-typeahead' tabIndex={tabIndex} style={{justifyContent: 'flex-end', paddingRight: '30px'}}>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <FontAwesomeIcon icon='circle-notch' size='1x' spin />
        </div>
      </div>
    );
  }
  

  // render the list of options
  return (
    <div className='portfolio-hub-typeahead' tabIndex={tabIndex}>
      <div className={Classnames('portfolio-hub-input', { loading })}>
        <Selector 
          strategiesToList={suggestions.filter(suggestion => !bannedSearches.includes(suggestion.ticker))} 
          placeholder={placeholder}
          handleEntitySelection = {handleEntitySelection}          
          />
      </div>
    </div>
  )
}

export default TickerSelect
